var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.date)?_c('div',[_c('p',{staticClass:"text month"},[_vm._v(" "+_vm._s(_vm.month)+" ")]),_c('p',{staticClass:"text day"},[_vm._v(" "+_vm._s(_vm.day)+" ")]),_c('p',{staticClass:"text time"},[_vm._v(" "+_vm._s(_vm.time)+" "+_vm._s(_vm.pm ? 'pm' : 'am')+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }